(ns app.members.styles
  (:require-macros)
  (:require
   [spade.core   :refer [defglobal defclass]]))

(defclass settings-card
  []
  {:background "white"
   :padding "22px 33px"
   :border-radius "10px"
   :border "1px solid"
   :border-color :theme/*grey400*})

(defclass settings-panel
  []
  {:margin-top "24px"
   :padding-top "23px"})

(defclass members-container
  []
  {:border-radius "12px"
   :border "1px solid"
   :border-color :theme/*dark98*
   :overflow-x "hidden"
   :overflow-y "auto"})
(defclass tab-root
  []
  {:background-color :theme/*purplePrimary*})

(defclass members-table
  []
  {:border-top "1px solid"
   :border-color :theme/*dark98*})
(defclass tab-container
  []
  {:color :theme/*purplePrimary*
   :padding "0px 24px"}
  [:.Mui-selected {:color :theme/*purplePrimary*}]
  [:.MuiButtonBase-root {:min-width "fit-content"
                         :padding "0px"
                         :font-family "'Nunito Sans' !important"
                         :color :theme/*dark40*
                         :font-weight "800"
                         :font-size "14px"
                         :text-transform "none"
                         :margin "0px 10px"}])
(defclass avatar-style []
  {:width "48px"
   :height "48px"
   :background :theme/*grey400*
   :border-radius "50%"
   :text-align "center"
   :align-items "center"
   :display "flex"
   :justify-content "center"
   :font-weight "700"})